import React from 'react';
import { Input, InputProps } from 'antd';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  required?: boolean;
  label?: string;
  error?: string;
  onChange?: (e) => void;
  name?: string;
}

export function InputText(props: Props & InputProps) {
  const { className, classNameLabel, label, classNameInput, name, error, required, ...prop } =
    props;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 block', classNameLabel)}
        >
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <Input
        name={name}
        className={twMerge('border border-gray_300 disabled:text-gray-900', classNameInput)}
        size="large"
        status={error ? 'error' : ''}
        {...prop}
      />
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
